import styled from 'styled-components'
import { belowPhone } from 'utilities/styled'
import { aspectRatio as a } from '../s'

export const EmbedWrapper = styled.div`
    position: relative;

    margin: auto;
    width: calc(100vw - 10em);
    aspect-ratio: ${a.width} / ${a.height};

    ${belowPhone`
        width: calc(100vw - 48px);
    `}
`

export const Iframe = styled.iframe`
    border: 0;
    width: 100%;
    height: 100%;
`